<template>
    <div class="music-course">
        <div class="course-header">
            <div class="course-content">
                <div class="qtz-course"><img src="../../assets/imgs/course/music-course-title-icon.png" alt="">专项能力课-音感课</div>
                <ul class="course-detail">
                    <li>音感课堂旨在提升幼儿对基础音乐要素，</li>
                    <li>即节奏、旋律、和声、音色、力度、速度的音乐感受能力，</li>
                    <li>同时为日后的乐器学习打下基础。</li>
                </ul>
            </div>
        </div>

        <div class="section-content">
            <img src="../../assets/imgs/course/music-course-1.png" style="position: relative;top:-200px;" alt="">
        </div>

        <div class="course-content" style="position: relative;top: -200px;">
            <div class="course-content max-title" style="margin-bottom:0;border-bottom: none">
                <span>特色环节</span>
                <span>Characteristic games</span>
            </div>
            <div class="content-item">
                <div class="content-title">
                    <button class="page-btn">情景体验</button>
                </div>
            </div>
            <ul class="list-text">
                <li>课程分为春夏秋冬四个季节,难度逐渐增加,每个季节6个主题(12课时)。通过不同的主</li>
                <li>题音乐和幻灯片、可爱的服装和道具,引导孩子对音乐的感知并且表演出来。</li>
            </ul>

            <ul class="list-text">
                <li style="display: flex;">
                    <img style="margin-right:60px" src="../../assets/imgs/course/music-course-5.png" alt="">
                    <img style="margin-right:60px" src="../../assets/imgs/course/music-course-6.png" alt="">
                    <img style="margin-right:60px" src="../../assets/imgs/course/music-course-7.png" alt="">
                    <img style="margin-right:60px" src="../../assets/imgs/course/music-course-8.png" alt="">
                </li>
            </ul>

            <div class="content-item" style="margin-top: 80px;">
                <div class="content-title">
                    <button class="page-btn">音符直观像</button>
                </div>
            </div>

            <ul class="list-text" style="display: flex;justify-content: space-between;align-items: center">
                <li style="flex-grow:9;">
                    <img style="margin-right:60px" src="../../assets/imgs/course/music-course-2.png" alt="">
                </li>
                <li style="flex-grow:10;">
                    <div>用照相机游戏的方式来认识音符,丰富的音符素材</div>
                    <div>和瞬间记忆的方式,让音符们变得有趣又好记。</div>
                    <div></div>
                </li>
            </ul>

            <div class="content-item" style="margin-top: 80px;">
                <div class="content-title">
                    <button class="page-btn">手工美劳</button>
                </div>
            </div>

            <ul class="list-text" style="display: flex;justify-content: space-between;align-items: center">
                <li>
                    <div>音感课每个主题都会加入音感手工美劳,家长</div>
                    <div>和宝贝们一起进入亲子DY时刻,制作出可爱的</div>
                    <div>艺术品带回家吧!</div>
                </li>
                <li>
                    <img style="margin-right:60px" src="../../assets/imgs/course/music-course-3.png" alt="">
                </li>
            </ul>

            <div class="content-item" style="margin-top: 80px;">
                <div class="content-title">
                    <button class="page-btn">儿童演唱</button>
                </div>
            </div>

            <ul class="list-text">
                <li>
                    <div>七田真音感课的24个主题都有不同的儿歌让宝贝们学习,并且可以到小舞台上</div>
                    <div>来展现自己,在老师的伴奏下演奏,勇敢地闪光吧!</div>
                </li>
            </ul>

            <div class="content-item" style="margin-top: 80px;">
                <div class="content-title">
                    <button class="page-btn" style="width:250px;">趣味练耳 & 旋律音感闪卡</button>
                </div>
            </div>

            <ul class="list-text" style="display: flex;justify-content: space-between;align-items: center">
                <li>
                    <div>通过按铃和钢琴,来辨别不同的音高,</div>
                    <div>加上音乐游戏来培养宝贝的相对音</div>
                    <div>感和绝对音感能力</div>
                </li>
                <li>
                    <img style="margin-right:60px" src="../../assets/imgs/course/music-course-4.png" alt="">
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "music-course"
    }
</script>

<style scoped lang="less">
    .music-course{
        .course-header{
            background-image: url("../../assets/imgs/course/memory-course-bg.png");
        }
        .content-item{
            border-top: 1px solid #F8B300;
        }
        .page-btn{
            background: #F8B300;
        }
        .max-title{
            color: #F8B300;
            border-bottom: 1px solid #F8B300;
        }
        .list-text{
            margin: 30px 0;
            color: #6A6767;
            font-size: 16px;
            font-family: Light;
            li{
                img{
                    margin-right: 15px;
                }
            }
        }
    }
</style>